/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { useTranslation } from 'react-i18next';
import SupportPhoneNumber from '@/components/support-phone-number';

export default function CheckoutFooter() {
    const { t } = useTranslation('footer');

    return (
        <footer className="mt-auto border-t border-footer-foreground/25 bg-footer-background text-footer-foreground">
            <div className="section-container flex flex-col md:flex-row gap-10 md:gap-0 md:items-center justify-between py-10 lg:py-16">
                <div className="contents flex flex-col md:flex-row gap-2 md:gap-4 md:items-center">
                    <span className="text-xs leading-4 text-footer-foreground">{t('footerBottom.questionsHelp')}</span>
                    <SupportPhoneNumber />
                </div>

                <p className="text-xs leading-4 text-footer-foreground">{t('footerBottom.copyright')}</p>
            </div>
        </footer>
    );
}
